import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Container,
  Form,
  RequiredField,
  WarningInputMessage,
} from "../../styles/GlobalStyles";
import {
  Content,
  CardHeader,
  CardTitle,
  CategoryTitle,
  InputContainer,
  CustomButton,
  FormSection,
  CourseDiv,
  InputContainerCourse,
  InputContainerYear,
  DisabledCustomButton,
  TermsText,
  LinkText,
  FileButton,
  ForgetPasswordContainer,
  ForgetPassword,
} from "./styled";
import { Checkbox, MenuItem, Select } from "@mui/material";

import api from "../../api/axios";

import { BRAZILIAN_STATES } from "../../constants/brazilianStates";
import ReactInputMask from "react-input-mask";
import WhatsappButton from "../../components/WhatsappButton";
import { toast } from "react-toastify";
import { Checkboxes } from "../../components/Checkboxes";

import { useDispatch } from "react-redux";
import * as actions from "../../store/modules/auth/actions";
import ReCAPTCHA from "react-google-recaptcha";

export default function RegisterShort() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const recaptchaRef = useRef();
  const fileInputRef = useRef();
  const { paramId } = useParams();

  const [skills, setSkills] = useState([]);

  const [isShowingFields, setIsShowingFields] = useState(false);
  const [isShowingPassword, setIsShowingPassword] = useState(false);

  const [userData, setUserData] = useState({
    email: "",
  });
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState(null);
  const [personalData, setPersonalData] = useState({
    name: "",
    phone: "",
    address: "",
  });
  const [address, setAddress] = useState({
    street: "",
    number: "",
    city: "",
    state: "",
    district: "",
    cep: "",
  });
  const [linkedin, setLinkedin] = useState("");
  const [curriculum, setCurriculum] = useState(null);
  const [professionalData, setProfessionalData] = useState({
    skills: [],
  });
  const [oportunityData, setOportunityData] = useState({});

  const [agreedTerms, setAgreedTerms] = useState(false);
  const [isSendingForm, setIsSendingForm] = useState(false);

  const [error, setError] = useState("");

  const resetValues = () => {
    setPersonalData({
      name: "",
      phone: "",
      address: "",
    });
    setAddress({
      street: "",
      number: "",
      city: "",
      state: "",
      district: "",
      cep: "",
    });
    setLinkedin("");
    setCurriculum(null);
    setProfessionalData({
      skills: [],
    });
  };

  const getOportunity = async () => {
    try {
      const oportunityData = await api.get(`/oportunity/search/${paramId}`);
      setOportunityData(oportunityData.data);

      const skillsData = await api.get(`/skill/list`);
      const skillsOportunity = [];

      skillsData.data?.forEach((skill) => {
        if (oportunityData.data?.skills?.includes(skill.name)) {
          skillsOportunity.push(skill);
        }
      });

      setSkills(skillsOportunity);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro: ", err);
    }
  };

  const validateFields = () => {
    const errors = [];

    if (personalData.phone.length !== 15) {
      errors.push("Telefone inválido.");
    }

    if (
      (address.cep && address.cep.length !== 9) ||
      (address.cep && !address.street)
    ) {
      errors.push("CEP inválido.");
    }

    if (address.street && !address.number) {
      errors.push("O número é obrigatório");
    }

    return errors.length === 0;
  };

  const isFormComplete = () => {
    const allFields = {
      ...userData,
      name: personalData.name,
      phone: personalData.phone,
      // ...address,
    };

    return Object.values(allFields).every((value) => value.trim() !== "");
  };

  const availableEmail = async () => {
    let status;

    await api
      .post("/user/verify-email", { email: userData.email })
      .then((res) => (status = res.data.status))
      .catch((err) => toast.error(err));
    return status;
  };

  const formValidation = async () => {
    if (!agreedTerms && isShowingFields) {
      setError("Para se inscrever, é necessário concordar com os termos");
      return false;
    }

    if (!isFormComplete()) {
      setError("Por favor, preencha todos os campos");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(userData.email)) {
      setError("Por favor, insira um e-mail válido");
      return false;
    }

    const isEmailAvailable = await availableEmail();
    if (!isEmailAvailable) {
      setError("Este email já está cadastrado");
      return false;
    }

    const isFieldsValid = validateFields();
    if (!isFieldsValid) {
      setError("Por favor, verifique os campos novamente");
      return false;
    }

    return true;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setIsSendingForm(true);

    const isFormValid = await formValidation();
    if (!isFormValid) {
      setIsSendingForm(false);
      return;
    }

    const professional = {
      ...personalData,
      ...professionalData,
      address: {
        ...address,
        street: `${address.street}, ${address.number}`,
      },
      linkedin,
    };

    delete professional.address.number;

    try {
      const formData = new FormData();

      if (curriculum) {
        formData.append("curriculum", curriculum);
      }
      formData.append("userData", JSON.stringify({ ...userData }));
      formData.append("professional", JSON.stringify({ ...professional }));
      formData.append("oportunity", paramId);

      const fileRes = await api.post("/file/get-latest", {
        name: "Termos",
      });

      formData.append("fileAgreedId", fileRes.data.latest._id);

      const res = await api.post("/user/create-short", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200) toast.success("Candidatura enviada!");
    } catch (err) {
      toast.error("Erro desconhecido: " + err);
      setError("Erro desconhecido");
      setIsSendingForm(false);
      return;
    }

    window.location.href = "https://ticoopbrasil.coop.br/oportunidades-ti/";
  }

  const handleCaptcha = (value) => {
    setCaptcha(value);
  };

  async function handleLogin(e) {
    e.preventDefault();
    setIsSendingForm(true);
    setError("");

    const { email } = userData;

    if (!email || !password) {
      setError("Por favor, preencha todos os campos!");
      setIsSendingForm(false);
      return;
    }

    if (!captcha) {
      setError("Por favor, preencha o captcha!");
      setIsSendingForm(false);
      return;
    }

    try {
      await api.post("/user/login", { email, password, captcha });

      dispatch(
        actions.loginRequest({
          email,
          password,
          onSuccess: () => navigate(`/candidatar/${paramId}`),
        }),
      );
    } catch (error) {
      setIsSendingForm(false);
      setError(error.response?.data?.error || "Erro desconhecido");

      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
        setCaptcha(null);
      }
    }
  }

  const handleBackButtonClick = () => {
    navigate("/");
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setCurriculum(file);
  };

  const handleCurriculumClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleEmailChange = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(userData.email)) {
      setError("Por favor, insira um e-mail válido");
      return;
    }

    const emailExists = await availableEmail();

    if (!emailExists) {
      resetValues();
      setIsShowingFields(false);
      setIsShowingPassword(true);
    } else {
      setIsShowingFields(true);
      setIsShowingPassword(false);
    }
  };

  const handlePasswordForgetClick = () => {
    navigate("/esqueci-senha", {
      state: { backOportunities: true },
    });
  };

  const handleTermClick = async () => {
    try {
      const res = await api.post("/file/get-signed-url", {
        name: "Termos",
      });
      if (res.status === 200) {
        window.open(res.data.signedUrl, "_blank");
      } else {
        toast.error("Ocorreu um erro");
      }
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.log(err);
    }
  };

  useEffect(() => {
    setError("");
  }, [userData, personalData, address]);

  useEffect(() => {
    getOportunity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Content>
      <WhatsappButton />
      <Container>
        <CardHeader>
          <a href="https://ticoopbrasil.coop.br/oportunidades-ti/">
            <img
              src="https://ticoopbrasil.coop.br/wp-content/uploads/2020/12/logo-ticoop-cor.png.webp"
              alt="Logo Ticoop"
            />
          </a>
          <CardTitle>
            {!userData.email ? (
              <>Insira seu e-mail</>
            ) : isShowingPassword ? (
              <>
                Entre na sua conta para
                <br />
                se candidatar
              </>
            ) : (
              <>
                Faça seu cadastro
                <br />
                GRATUITO
              </>
            )}
          </CardTitle>
          <CustomButton onClick={handleBackButtonClick}>
            Voltar ao site
          </CustomButton>
        </CardHeader>
        <Form>
          <FormSection>
            <InputContainer>
              {/* E-mail */}
              <label for="email">
                E-mail:
                <RequiredField title="Campo obrigatório">*</RequiredField>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={userData.email}
                onChange={(e) => {
                  setUserData({
                    ...userData,
                    email: e.target.value.toLocaleLowerCase(),
                  });
                }}
                onBlur={(e) => {
                  handleEmailChange();
                }}
              />
              {userData.email.length > 0 &&
              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email) ? (
                <WarningInputMessage>
                  Insira um e-mail válido.
                </WarningInputMessage>
              ) : (
                <></>
              )}
            </InputContainer>
            {isShowingPassword ? (
              <>
                <InputContainer>
                  <label for="password">Senha:</label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError("");
                    }}
                  />
                </InputContainer>
                <ForgetPasswordContainer>
                  <ForgetPassword onClick={handlePasswordForgetClick}>
                    Esqueci minha senha
                  </ForgetPassword>
                </ForgetPasswordContainer>
                <ReCAPTCHA
                  sitekey="6LdfQmQrAAAAAIPfiDlA7XO9JK85WeAzyO7vRSov"
                  onChange={handleCaptcha}
                  ref={recaptchaRef}
                />
              </>
            ) : (
              <></>
            )}
          </FormSection>
          {isShowingFields ? (
            <FormSection>
              <CategoryTitle>Dados Pessoais</CategoryTitle>
              <InputContainer>
                {/* Full name */}
                <label for="name">
                  Nome Completo:
                  <RequiredField title="Campo obrigatório">*</RequiredField>
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={personalData.name}
                  onChange={(e) =>
                    setPersonalData({ ...personalData, name: e.target.value })
                  }
                />
              </InputContainer>
              <InputContainer>
                {/* Phone */}
                <label for="phone">
                  Telefone:
                  <RequiredField title="Campo obrigatório">*</RequiredField>
                </label>
                <ReactInputMask
                  mask={"(99) 99999-9999"}
                  maskChar={null}
                  value={personalData.phone}
                  onChange={(e) =>
                    setPersonalData({ ...personalData, phone: e.target.value })
                  }
                >
                  {(inputProps) => (
                    <input
                      {...inputProps}
                      id="phone"
                      name="phone"
                      type="text"
                    />
                  )}
                </ReactInputMask>
                {personalData.phone.length !== 15 &&
                personalData.phone !== "" ? (
                  <WarningInputMessage>
                    Insira um número válido.
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                {/* CEP */}
                <label for="cep">CEP:</label>
                <ReactInputMask
                  mask={"99999-999"}
                  maskChar={null}
                  value={address.cep}
                  onChange={(e) => {
                    setAddress({ ...address, cep: e.target.value });
                  }}
                  onBlur={async () => {
                    const cepSemHifen = address.cep.replace("-", "");

                    if (cepSemHifen.length === 8) {
                      try {
                        const response = await api.get(
                          `https://viacep.com.br/ws/${cepSemHifen}/json`,
                        );

                        if (response.data && !response.data.erro) {
                          setAddress({
                            ...address,
                            street: response.data.logradouro || "",
                            district: response.data.bairro || "",
                            city: response.data.localidade || "",
                            state: response.data.estado || "",
                            cep: address.cep,
                          });
                        } else {
                          setAddress({
                            ...address,
                            street: "",
                            district: "",
                            city: "",
                            state: "",
                          });
                        }
                      } catch (error) {
                        setAddress({
                          ...address,
                          street: "",
                          district: "",
                          city: "",
                          state: "",
                        });
                      }
                    }
                  }}
                >
                  {(inputProps) => (
                    <input {...inputProps} id="cep" name="cep" type="text" />
                  )}
                </ReactInputMask>
                {(address.cep.length === 9 &&
                  !address.street &&
                  !address.city) ||
                (address.cep !== "" && address.cep.length !== 9) ? (
                  <WarningInputMessage>
                    Insira um CEP válido.
                  </WarningInputMessage>
                ) : null}
              </InputContainer>
              <CourseDiv>
                <InputContainerCourse>
                  {/* Address */}
                  <label for="street">Rua:</label>
                  <input
                    id="street"
                    name="street"
                    type="text"
                    value={address.street}
                    disabled
                  />
                </InputContainerCourse>
                <InputContainerYear>
                  <label for="number">
                    Número:{" "}
                    {address.street && (
                      <RequiredField title="Campo obrigatório">*</RequiredField>
                    )}
                  </label>
                  <input
                    id="number"
                    name="number"
                    type="text"
                    value={address.number}
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        number: e.target.value,
                      })
                    }
                  />
                </InputContainerYear>
              </CourseDiv>
              <InputContainer>
                {/* City */}
                <label for="city">Cidade:</label>
                <input
                  id="city"
                  name="city"
                  type="text"
                  value={address.city}
                  disabled
                />
              </InputContainer>
              <InputContainer>
                <label for="state">Estado:</label>
                <Select
                  id="state"
                  name="state"
                  value={address.state}
                  sx={{
                    backgroundColor: "#FFF",
                    height: "50px",
                    textAlign: "start",
                    fontSize: "0.9rem",
                  }}
                  disabled
                >
                  {BRAZILIAN_STATES.map((state) => (
                    <MenuItem value={state}>{state}</MenuItem>
                  ))}
                </Select>
              </InputContainer>
              <InputContainer>
                {/* District */}
                <label for="district">Bairro:</label>
                <input
                  id="district"
                  name="district"
                  type="text"
                  value={address.district}
                  disabled
                />
              </InputContainer>
            </FormSection>
          ) : (
            <></>
          )}

          {isShowingFields ? (
            <FormSection>
              <CategoryTitle>Informações Profissionais</CategoryTitle>
              <InputContainer>
                {/* Linkedin */}
                <label for="linkedin">Linkedin:</label>
                <input
                  id="linkedin"
                  name="linkedin"
                  type="text"
                  value={linkedin}
                  onChange={(e) => setLinkedin(e.target.value)}
                />
              </InputContainer>
              <FileButton onClick={handleCurriculumClick}>
                {"Adicionar Currículo"}
              </FileButton>
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <span style={{ color: "#104467", fontSize: "0.8rem" }}>
                {curriculum ? `Arquivo adicionado: ${curriculum.name}` : ""}
              </span>
            </FormSection>
          ) : (
            <></>
          )}

          {isShowingFields ? (
            <FormSection>
              <CategoryTitle>Sobre a Oportunidade</CategoryTitle>
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <span>{oportunityData.cargo}</span>
              </div>

              <TermsText>
                {"Marque as opções que você possui conhecimento:"}
              </TermsText>
              <div style={{ width: "100%" }}>
                <Checkboxes
                  options={skills}
                  data={professionalData}
                  setData={setProfessionalData}
                  re
                />
              </div>
            </FormSection>
          ) : (
            <></>
          )}

          <div className="erro">{error}</div>
          {isShowingFields && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                value={agreedTerms}
                onChange={() => {
                  setError("");
                  setAgreedTerms(!agreedTerms);
                }}
              />
              <div>
                <TermsText>
                  Ao me inscrever, concordo com os{" "}
                  <LinkText onClick={handleTermClick}>
                    Termos e Condições
                  </LinkText>{" "}
                  do site
                </TermsText>
              </div>
            </div>
          )}
          {isSendingForm ? (
            <DisabledCustomButton onClick={(e) => e.preventDefault()}>
              {isShowingPassword ? "Login" : "Cadastrar"}
            </DisabledCustomButton>
          ) : (
            <CustomButton
              type="submit"
              onClick={isShowingPassword ? handleLogin : handleSubmit}
            >
              {isShowingPassword ? "Login" : "Cadastrar"}
            </CustomButton>
          )}
        </Form>
      </Container>
    </Content>
  );
}
